import(/* webpackMode: "eager" */ "/private/tmp/mosquarium-nextjs-deploy/app/page.tsx");
